// extracted by mini-css-extract-plugin
export default {"embargo-warning":"EmbargoWarning_embargo-warning__rOWrJ","embargoWarning":"EmbargoWarning_embargo-warning__rOWrJ"};